module.exports = __webpack_public_path__ + "img/grey1.71d3c2dd.png";